import * as React from 'react';
import { memo } from 'react';

const SvgComponent = (props) => (
  <svg width={220} height={42} xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <linearGradient x1="50%" y1="113.076%" x2="50%" y2="-15.922%" id="a">
        <stop stopColor="#F49797" stopOpacity={0} offset="0%" />
        <stop stopColor="#E55E5E" offset="100%" />
      </linearGradient>
      <linearGradient x1="5.234%" y1="66.402%" x2="95.437%" y2="66.402%" id="b">
        <stop stopColor="#E55E5E" stopOpacity={0} offset="0%" />
        <stop stopColor="#EE8282" offset="56.443%" />
        <stop stopColor="#F49797" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d={props.patharea} fill="url(#a)" opacity={0.209} />
      <path
        d={props.pathline}
        stroke="url(#b)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const Memo = memo(SvgComponent);
export default Memo;
